import { render, staticRenderFns } from "./ItemAlert.vue?vue&type=template&id=9bb65bd4&scoped=true"
import script from "./ItemAlert.vue?vue&type=script&lang=ts"
export * from "./ItemAlert.vue?vue&type=script&lang=ts"
import style0 from "./ItemAlert.vue?vue&type=style&index=0&id=9bb65bd4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb65bd4",
  null
  
)

export default component.exports